

export function H1({ children }) {
  return <h1 style={{ fontSize: '3em', fontWeight: 'bold', lineHeight: 1.2 }}>{children}</h1>
}

export function H2({ children }) {
  return <h2 style={{ fontSize: '2.2em', fontWeight: 'bold', lineHeight: 1.2 }}>{children}</h2>
}

export function CTAText({ children }) {
  return <h4 style={{ fontSize: '2em', lineHeight: 1.4 }}>{children}</h4>
}

export function SubText({ children }) {
  return <h4 style={{ fontSize: '1.4em', color: '#666', lineHeight: 1.4, color: 'grey', textAlign: 'center' }}>{children}</h4>
}

export function DetailText({ children }) {
  return <p style={{ fontSize: '1.5em', textAlign: 'center' }}>{children}</p>
}

export function SpacedText({ children }) {
  return <p style={{ fontSize: '1.2em', lineHeight: 1.2, letterSpacing: 3, textTransform: 'uppercase', color: 'grey' }}>{children}</p>
}
